import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { TruncatedCell } from '@/components';
import type { Facesheet, ViewFacesheetSummaryParams } from './types';
import { ViewFacesheetAssetsMenu } from './ViewFacesheetAssetsMenu';

// Helper to check if value is nullish (null, undefined, or empty string)
const isNullish = (value?: string | null): boolean => {
  return value === null || value === undefined || value === '';
};

// Helper to format "Name <email>" display
const formatRequestedBy = (name?: string, email?: string): string => {
  if (isNullish(name) && isNullish(email)) return 'Not found';
  if (!isNullish(name) && !isNullish(email)) return `${name} <${email}>`;
  return name || email || 'Not found';
};

interface ColumnFactoryProps {
  onViewImage: (signedUrl: string) => void;
  onViewFacesheet: (params: ViewFacesheetSummaryParams) => void;
}

export const createColumns = ({
  onViewImage,
  onViewFacesheet,
}: ColumnFactoryProps): ColumnDef<Facesheet>[] => [
  {
    accessorKey: 'name',
    header: 'Facesheet Name',
    size: 300,
    cell: ({ row }) => <TruncatedCell text={row.original.name} />,
  },
  {
    accessorKey: 'uploadedAt',
    header: 'Date Uploaded',
    cell: ({ row }) => {
      const date = row.original.uploadedAt;
      return date ? format(new Date(date), 'MM/dd/yyyy') : 'Not found';
    },
  },
  {
    accessorKey: 'requestedAt',
    header: 'Date Requested',
    cell: ({ row }) => {
      const date = row.original.requestedAt;
      return date ? format(new Date(date), 'MM/dd/yyyy') : 'Not found';
    },
  },
  {
    id: 'requestedBy',
    header: 'Requested By',
    cell: ({ row }) =>
      formatRequestedBy(
        row.original.requestedByName,
        row.original.requestedByEmail,
      ),
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => (
      <div className="flex items-center justify-end">
        <ViewFacesheetAssetsMenu
          facesheetRequestId={row.original.facesheetRequestId}
          facesheetName={row.original.name}
          version={row.original.version}
          resultsSummaries={row.original.resultsSummaries}
          sources={row.original.sources}
          onViewImage={onViewImage}
          onViewFacesheet={onViewFacesheet}
        />
      </div>
    ),
  },
];
